import { flagEnumContainsValue } from '../../../../base/utils/flag-enum-contains-value-utils';
import { PlaceButtonStates } from '../../state';

export function isUpdateStakeState(action: PlaceButtonStates): boolean {
    return flagEnumContainsValue(action, PlaceButtonStates.UpdateStake) || flagEnumContainsValue(action, PlaceButtonStates.UpdateStakes);
}
